import moment from 'moment';

/**
 * The sub-period selected by default: the most recently completed window — the
 * latest one whose date range is fully in the past (endDate before today).
 * "Completed" here means elapsed, not a status. When no window has elapsed yet
 * (we're in or before the first window) it falls back to the earliest window.
 * Sub-periods arrive ordered ascending by startDate. Returns undefined when
 * there are no sub-periods.
 */
const getDefaultSubPeriod = (
  subPeriods: Period[] | undefined,
): Period | undefined => {
  if (!subPeriods || subPeriods.length === 0) {
    return undefined;
  }

  const today = moment().format('YYYY-MM-DD');
  const completed = subPeriods.filter((sp) => sp.endDate < today);
  if (completed.length > 0) {
    return completed[completed.length - 1];
  }

  return subPeriods[0];
};

export default getDefaultSubPeriod;
